import { render } from "./FuentesMacro.vue?vue&type=template&id=2a64f93e"
import script from "./FuentesMacro.vue?vue&type=script&lang=js"
export * from "./FuentesMacro.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__